// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"3e7ac208","515":"65082937","518":"e9a47f2a","586":"db2603eb","642":"c6fbd270","991":"226dc423"}[chunkId] + ".chunk.js";
};